import { isArray, isNonNullObject, isNumber } from '@dazn/peng-html5-tools-utils';
import { isValidMhid } from './isValidMhid';
/**
 * Validates a message container
 */
var isValidMessageContainer = function (input) {
    return isNonNullObject(input) &&
        'c' in input &&
        isValidMhid(input.c) &&
        'u' in input &&
        isNumber(input.u) &&
        'm' in input &&
        isArray(input.m) &&
        'p' in input &&
        isArray(input.p) &&
        't' in input &&
        isNonNullObject(input.t);
};
export { isValidMessageContainer };
//# sourceMappingURL=isValidMessageContainer.js.map